<div class="p-2">
  <h2 mat-dialog-title>Implementation Plan - {{data.targetCategoryName}} ({{data.targetConditionName}})</h2>
  <div class="ps-4" style="font-size:14px">
    What is the plan for implementing and achieving the target goal?
  </div>
</div>

<mat-dialog-content>
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="goal-plan-container">
    <div>
      <mat-slide-toggle [(ngModel)]="showGoal">Show Goal</mat-slide-toggle>
    </div>
    @if (showGoal()) {
      <div class="d-flex d-inline-flex p-2" style="white-space:normal;">
        <span [innerHTML]="data.targetConditionDescription"></span>
      </div>
    }
    <hr>
    <div class="d-flex flex-row" style="font-size:20px;justify-content:center;">Project Team Plan:
      @if (data.isLocked) {
        <fa-icon  style="padding-left:10px;" [icon]="faLock"
          matTooltip="This plan is locked. To unlock, go back and turn on roadmap editing."
          matTooltipPosition="right" matTooltipShowDelay="150">
        </fa-icon>
      }
    </div>
    <div class="py-2">
      <mat-form-field appearance="fill" class="goal-plan">
          <mat-label>What's your implementation plan?</mat-label>
          <textarea matInput [disabled]="data.isLocked" [class.locked-goalplan]="data.isLocked" autocomplete="off" [(ngModel)]="data.goalPlan" rows="4"></textarea>
      </mat-form-field>
    </div>
    <div class="d-flex flex-row">
      <div class="p-2 me-auto">
        @if (data.isLocked) {
          <p style="color:red">Roadmap and plan are currently locked in.</p>
        }
      </div>
      <div class="pt-2 ms-auto" style="display:inline-flex">
        <button mat-button type="button" style="color: #f44336c7" class="icon-btn" (click)="close()" matTooltip="Close the goal plan, no changes are saved."
          matTooltipPosition="right" matTooltipShowDelay="150">
          <fa-icon [icon]="faWindowClose"></fa-icon>
        </button>
        @if (!data.isLocked) {
          <button  mat-button type="button" default style="color: #0071bbc2" (click)="save()" class="icon-btn" matTooltip="Save this goal plan and close the window."
            matTooltipPosition="right" matTooltipShowDelay="150" [disabled]="!data.goalPlan || data.goalPlan.trim() === ''">
            <fa-icon [icon]="faReply"></fa-icon>
          </button>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>
